import React, { useState } from 'react';
import { ArrowRight, TrendingUp, Shield, FileText, Users, Download, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const PortfolioSection = () => {
  const [showQRDropdown, setShowQRDropdown] = useState(false);

  return (
    <section id="portfolio" className="portfolio-section" data-testid="portfolio-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Track Your Portfolio</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">Invest, Access and Track your investments anytime, anywhere</p>
        </div>
        <div className="portfolio-cta-box">
          <h3 className="portfolio-cta-title">Access Your Portfolio Online</h3>
          <p className="portfolio-cta-text">
            Login to our comprehensive portfolio tracking platform to monitor your investments in real-time,
            view detailed reports, and track your financial growth.
          </p>
          <p className="portfolio-cta-text">
            <strong>Invest, Access, and Track</strong> your investments in real-time.
            Our comprehensive platform gives you complete control over your portfolio anytime, anywhere.
          </p>
          <a href="https://apkfintech.my-portfolio.co.in/app/#/login" target="_blank" rel="noopener noreferrer">
            <Button className="btn-primary portfolio-btn" data-testid="portfolio-tracker-btn">
              Visit Portfolio Tracker <ArrowRight size={20} />
            </Button>
          </a>

          {/* QR Code Dropdown */}
          <div className="qr-dropdown-container" style={{ marginTop: '24px' }}>
            <button
              className="qr-dropdown-toggle"
              data-testid="qr-dropdown-btn"
              onClick={() => setShowQRDropdown(!showQRDropdown)}
            >
              <Download size={18} />
              Download Mobile App
              <ChevronDown size={18} style={{ transform: showQRDropdown ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.3s ease' }} />
            </button>
            {showQRDropdown && (
              <div className="qr-dropdown-content" data-testid="qr-dropdown-content">
                <div className="qr-dropdown-grid">
                  <div className="qr-dropdown-item">
                    <h5 className="qr-dropdown-label">iOS App</h5>
                    <div className="qr-code-wrapper-small">
                      <img
                        src="https://customer-assets.emergentagent.com/job_asset-planner-3/artifacts/w6w3tlra_image.png"
                        alt="iOS App QR Code"
                        className="qr-code-image-small"
                      />
                    </div>
                    <p className="qr-instruction-small">Scan for iPhone</p>
                  </div>
                  <div className="qr-dropdown-item">
                    <h5 className="qr-dropdown-label">Android App</h5>
                    <div className="qr-code-wrapper-small">
                      <img
                        src="https://customer-assets.emergentagent.com/job_asset-planner-3/artifacts/akytzq91_image.png"
                        alt="Android App QR Code"
                        className="qr-code-image-small"
                      />
                    </div>
                    <p className="qr-instruction-small">Scan for Android</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="app-features">
          <h4 className="features-title">Platform Features</h4>
          <div className="features-grid">
            <div className="feature-item">
              <TrendingUp size={24} className="feature-icon" />
              <span>Real-time Portfolio Tracking</span>
            </div>
            <div className="feature-item">
              <Shield size={24} className="feature-icon" />
              <span>Secure & Encrypted</span>
            </div>
            <div className="feature-item">
              <FileText size={24} className="feature-icon" />
              <span>Detailed Reports</span>
            </div>
            <div className="feature-item">
              <Users size={24} className="feature-icon" />
              <span>Expert Support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
